import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'
import About from './components/About'
import Contact from './components/Contact'
import Home from './components/Home'
import DrawerAppBar from './components/Navbar'
import Projects from './components/Projects'
import { colors } from './styles/styles'

const theme = createTheme({
  palette: { mode: 'dark', background: { default: colors.background, paper: colors.surface }, primary: { main: colors.accent }, text: { primary: colors.text, secondary: colors.muted } },
  typography: { fontFamily: 'Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  shape: { borderRadius: 8 },
})

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <DrawerAppBar />
    <main>
      <Home />
      <About />
      <Projects />
      <Contact />
    </main>
  </ThemeProvider>
)

export default App
